import Loadable from 'react-loadable';
import Loading from '../Loading';

export default Loadable({
  loader: () =>
    import(/* webpackChunkName: "RedemptionCatalog" */ '../../components/rewards/Tango/RedemptionCatalog'),
  loading: Loading(),
});
